import styled from 'styled-components';

import imageDesktop2x from '@wecasa/common/src/assets/images/recap/tax-modal-desktop@2x.jpg';
import imageDesktop3x from '@wecasa/common/src/assets/images/recap/tax-modal-desktop@3x.jpg';
import imageDesktop from '@wecasa/common/src/assets/images/recap/tax-modal-desktop.jpg';
import imageMobile2x from '@wecasa/common/src/assets/images/recap/tax-modal-mobile@2x.jpg';
import imageMobile3x from '@wecasa/common/src/assets/images/recap/tax-modal-mobile@3x.jpg';
import imageMobile from '@wecasa/common/src/assets/images/recap/tax-modal-mobile.jpg';

import type { TaxModalCleaningProps } from '@wecasa/customer/src/components/basket/types';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import Image from '@wecasa/web-ui/src/components/image/image';
import Modal, { ModalContent } from '@wecasa/web-ui/src/components/modal/modal';
import { useIsMobile } from '@wecasa/web-ui/src/styles/media-queries';

const TextWrapper = styled.div`
  margin-top: 20px;
`;

const StyledImage = styled(Image)`
  width: 100%;
  height: auto;
  border-radius: 10px;
`;

const t = translate('basket.cleaning.services.tax.modal');

// This TaxCreditInfoModal is only used in DE to inform the user about the tax credit

const TaxCreditInfoModal = ({ onClose, isOpen }: TaxModalCleaningProps) => {
  const isMobile = useIsMobile();
  const title = t('.title');
  return (
    <Modal
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={{
        children: t('base.got_it'),
        onPress: onClose,
      }}
    >
      <ModalContent>
        {isMobile ? (
          <StyledImage src={imageMobile} double={imageMobile2x} triple={imageMobile3x} alt={title} />
        ) : (
          <StyledImage src={imageDesktop} double={imageDesktop2x} triple={imageDesktop3x} alt={title} />
        )}
        <TextWrapper>
          <Text>{t('.content.first_paragraph')}</Text>
        </TextWrapper>
        <TextWrapper>
          <Text>{t('.content.second_paragraph')}</Text>
        </TextWrapper>
        <TextWrapper>
          <Text>{t('.content.third_paragraph')}</Text>
        </TextWrapper>
      </ModalContent>
    </Modal>
  );
};

export default TaxCreditInfoModal;
